import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
export type TContextTarget = 'roadMapStep'|'contractParty'
export interface IContextMenuData {
  targetContext:TContextTarget,
  contractGuid:string,
  event:MouseEvent|null,
  data?:any
}
@Injectable({
    providedIn: 'root'
})
export class ContractContextMenuService {
  public subEidtContextMenu:Subject<IContextMenuData> = new Subject()
  public subCreateContextMenu:Subject<IContextMenuData> = new Subject()
  public subDeleteContextMenu:Subject<IContextMenuData> = new Subject()

  dispatchEditEvent(event:MouseEvent,targetContext:TContextTarget, data:any,contractGuid:string ) {
    this.subEidtContextMenu.next({targetContext:targetContext, event:event,data:data,contractGuid:contractGuid})
  }
  dispatchCreateEvent(event:MouseEvent,targetContext:TContextTarget, data:any,contractGuid:string) {
    this.subCreateContextMenu.next({targetContext:targetContext,event:event,data:data,contractGuid:contractGuid})
  }
  dispatchDeleteEvent(event:MouseEvent|null,targetContext:TContextTarget, data:any,contractGuid:string) {
    this.subDeleteContextMenu.next({targetContext:targetContext,event:event,data:data,contractGuid:contractGuid})
  }
}
